import React, { useCallback, useMemo } from "react";
import { IconButton } from "@mui/material";
import classNames from "classnames";
import { useSelector } from "react-redux";

import {
  Add,
  Info as EditIcon,
  OpenInNew as OpenInNewIcon,
  Edit,
  Topic,
} from "@mui/icons-material";
import { Typography } from "@mui/material";
import styles from "./Style.module.css";
import DataTables from "../../../../Datatables/Datatable.table";
import Constants from "../../../../config/constants";
import capitalizeFirstLetter from "../../../../hooks/CommonFunction";
import ShadowBox from "../../../../components/ShadowBox/ShadowBox";
import useProgramListHook from "./ProgramList.hook";

const ProgramList = ({ data }) => {
  const {
    handlePageChange,
    handleSortOrderChange,
    isFetching,
    currentData,
    currentPage,
  } = useProgramListHook({ data });

  const renderFirstCell = useCallback((user) => {
    return (
      <div className={styles.firstCellFlex}>
        <div className={classNames(styles.firstCellInfo, "openSans")}>
          <div>{`${capitalizeFirstLetter(user?.name)}`} </div>
          <div>{`${capitalizeFirstLetter(user?.code)}`} </div>
          <div> {user?.employee_id}</div>
        </div>
      </div>
    );
  }, []);


  const tableStructure = useMemo(
    () => [
      {
        key: "program",
        label: "Program Name",
        sortable: false,
        render: (temp, all) => (
          <div>{capitalizeFirstLetter(all?.name)}</div>
        ),
      },
      // {
      //   key: "client_name",
      //   label: "Client Name",
      //   sortable: false,
      //   render: (temp, all) => <div>{capitalizeFirstLetter(all?.client?.name)}</div>,
      // },
      {
        key: "user",
        label: "Enrolled Count",
        sortable: false,
        render: (value, all) => <div>{all?.enrolled_count}</div>,
      },
    ],
    [renderFirstCell]
  );
  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      // clickableRow: handleEditSidePannel,
    };
    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [currentData, currentPage, handlePageChange, handleSortOrderChange, tableStructure]);
  
  const panelTitle = "Top Programs";
  return (
    <div className={styles.wrapper}>
      <ShadowBox className={styles.w100}>
        <div className={styles.headerContainer}>
          <Typography
            variant={"title"}
            color={"text.primary"}
            className={styles.title}
          >
            {panelTitle}
          </Typography>
        </div>
        <div>
          <div>
            <br />
            <div className={styles.w100}>
              <DataTables
                width="100%"
                {...tableData.datatable}
                {...tableData.datatableFunctions}
                hidePagination={true}
              />
            </div>
          </div>
        </div>
      </ShadowBox>
    </div>
  );
};

export default ProgramList;
